import { QueryClient } from '@tanstack/react-query';

// Singleton QueryClient shared across the app to preserve cache lifecycle
// and allow explicit clearing on auth changes.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
});

